
const SET_ROLES_DATA = "rolesManagement.SET_ROLES_DATA"
const UPDATE_ROLES_LIST = "rolesManagement.UPDATE_ROLES_LIST"
const ADD_ROLE = "rolesManagement.ADD_ROLE"
const EDIT_ROLE = "rolesManagement.EDIT_ROLE"
const DELETE_ROLE = "rolesManagement.DELETE_ROLE"

const initialState = {
    roles: [],
    claims: [],
    filter: {
        pagesFilter: { pageCount: 1, currentPage: 1, maxItemsOnPage: 1},
        modelFilter: {}
    }
}

export default function reducer(state = {...initialState}, action){
    const {type, payload} = action;
    switch(type){
        case SET_ROLES_DATA: {
            const {roles, claims} = payload;

            return {
                ...state,
                roles,
                claims
            }

        }
        case UPDATE_ROLES_LIST: {
            const {roles} = payload;

            return {
                ...state,
                roles
            }
        }
        case ADD_ROLE: {
            const {role} = payload;
            return {
                ...state,
                roles: [...state.roles, role]
            };
        }
        case EDIT_ROLE: {
            const {role} = payload;
            const newState = {...state, roles: [...state.roles], claims: [...state.claims]};
            newState.roles = newState.roles.map((item) => {
                if(item.roleName !== role.roleName){
                    return item;
                }

                return {...item, ...role};
            });

            return newState;
        }
        case DELETE_ROLE: {
            const {roleName} = payload;
            const newState = {...state, roles: [...state.roles], claims: [...state.claims]};
            newState.roles = newState.roles.filter((item, index) => {
                return item.roleName !== roleName;
            });

            return newState;
        }
        default: {
            return state;
        }
    }
}

export const setRolesData = (roles, claims) => ({type: SET_ROLES_DATA, payload: {roles, claims}});
export const updateRolesList = (roles, filter) => ({type: UPDATE_ROLES_LIST, payload: {roles, filter}})
export const addRole = (role) => ({type: ADD_ROLE, payload: {role}});
export const editRole = (role) => ({type: EDIT_ROLE, payload: {role}});
export const removeRole = (roleName) => ({type: DELETE_ROLE, payload: {roleName}});